"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopArea = void 0;
var _mui = require("@ori-ui/mui");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _components = require("./components");
var _SponsorInfo = require("./components/SponsorInfo");
var _TopArea = require("./components/TopArea");
var _WalletAmountMessageBanner = require("./components/WalletAmountMessageBanner/WalletAmountMessageBanner");
var _constants = require("./constants");
var _constantsGenerated = require("./constants-generated");
var _Context = require("./containers/Context");
var _context = require("./context");
var _hooks = require("./hooks");
var _logger2 = require("./logger");
var _jsxRuntime = require("react/jsx-runtime");
// istanbul ignore file -- all submodules are tested

const Content = ({
  mobilePersonalMenuOutlet,
  removeQueryParameter,
  setQueryParameter
}) => {
  const {
    visible: isTopBannerVisible
  } = (0, _context.useTopAreaBanner)();
  (0, _hooks.useLoadAbTastyScript)();
  (0, _hooks.useManagedHeight)();
  (0, _hooks.useToggleMenuHandler)();
  (0, _components.useAddToBasketAnalytics)();
  (0, _hooks.useCookieToUrl)(setQueryParameter && removeQueryParameter ? {
    setQueryParameter,
    removeQueryParameter
  } : undefined);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.TopAreaBlock, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TopArea.TopArea, {
      isTopBannerVisible: isTopBannerVisible,
      mobilePersonalMenuOutlet: mobilePersonalMenuOutlet
    })
  });
};
const TopArea = ({
  configuration,
  mobilePersonalMenuOutlet,
  removeQueryParameter,
  setQueryParameter
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
  namespace: _constants.translationsNamespace,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_context.AppConfigProvider, {
    value: configuration,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
      team: _testidGenerator.Team.Presentation,
      project: _constantsGenerated.APP_NAME,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
        logger: _logger2.mainLogger,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Context.Context, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SponsorInfo.FloatingBanner, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_WalletAmountMessageBanner.WalletAmountMessageBanner, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.AppPromoBanner, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(Content, {
            mobilePersonalMenuOutlet: mobilePersonalMenuOutlet,
            removeQueryParameter: removeQueryParameter,
            setQueryParameter: setQueryParameter
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.NoSsr, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ShadePicker, {})
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.GlobalTopAreaStyles, {})]
        })
      })
    })
  })
});
exports.TopArea = TopArea;